var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"ma-0 pa-0 text-center",attrs:{"dark":_vm.isDark,"width":"100%"}},[_c('h3',{staticClass:"py-4"},[_c('strong',[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }